import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { map, Observable } from 'rxjs';

@Component({
    selector: 'app-comment-tab',
    templateUrl: './comment-tab.component.html',
    styleUrls: ['./comment-tab.component.scss']
})
export class CommentTabComponent implements OnInit {
    @Input() formGroupName: string = 'commentData';

    constructor(private rootForm: FormGroupDirective) {}

    form: FormGroup = new FormGroup({});
    userDataForm: FormGroup = new FormGroup({});

    commentMaxLength: string = '1000';
    accountingCommentMaxLength: string = '80';

    commentLength: Observable<number> | undefined = new Observable<number>();
    accountingCommentLength: Observable<number> | undefined = new Observable<number>();

    isGuestAccount$: Observable<boolean> | undefined = new Observable<boolean>();

    ngOnInit() {
        this.form = this.rootForm.control.get(this.formGroupName) as FormGroup;

        this.userDataForm = this.rootForm.control.get('userData') as FormGroup;

        // subscribe to changes of text fields and set new length
        this.commentLength = this.comment?.valueChanges.pipe(map((value) => value.length));

        this.accountingCommentLength = this.accountingComment?.valueChanges.pipe(map((value) => value.length));

        this.isGuestAccount$ = this.isGuestAccount?.valueChanges.pipe();
    }

    //getter
    get comment() {
        return this.form.get('comment');
    }
    get accountingComment() {
        return this.form.get('accountingComment');
    }
    get isGuestAccount() {
        return this.userDataForm.get('isGuestAccount');
    }
}
